import React, { useState, useEffect } from "react";
import { useAuth } from "../../api/services/auth";
import { Navigate, useNavigate } from "react-router-dom";
import bookmarkCasee from "../../api/services/bookmarkCase";
import { toast } from 'react-toastify';
import { HalfCircleSpinner } from 'react-epic-spinners';
import Popup from 'reactjs-popup';
import Pagination from "../../components/pagination";
import { sortData } from "../../utils";
import CaseSearch from "../../components/case-listing/caseSearch";
import { userPermissions, userRoles } from "../../enums";
import { deleteCase } from "../../api/services/cases";
import caseListing from "../../api/services/caseListing";

function DraftCases() {
    const navigate = useNavigate()
    const { userExist, permission, user } = useAuth()
    const [token, setToken] = useState(localStorage.getItem("authToken"));
    const [casesList, setCasesList] = useState([]);
    const [showFilters, setShowFilters] = useState(false);
    const [selectedCaseBookmark, setSelectedCaseBookmark] = useState(null);
    const [showLoader, setShowLoader] = useState(false);
    const [selectedCaseId, setSelectedCaseId] = useState(null);
    const [pagination, setPagination] = useState({});
    const [filteredSearch, setFilteredSearch] = useState(false)
    const [deleteId, setDeleteId] = useState(null)
    const [formData, setFormData] = useState({
        status: 'draft',
        comorbidity_id: '',
        complication_id: '',
        procedure_id: '',
        consultant_id: '',
        flag_status: '',
        reference: '',
        procedure_date: '',
        state: "all"
    });
    const [loading, setLoading] = useState(true);

    const [sorting, setSorting] = useState({
        column: null,
        order: 'asc'
    });
    let oneRequest = true;

    // Set the page Title for SEO purpose
    useEffect(() => {
        document.title = "Draft Cases | Cappagh";
    }, []);

    // Get token from LocalStorage
    useEffect(() => {
        setToken(localStorage.getItem("authToken"));

        if (token === undefined) {
            window.location.pathname = "/";
        }
    }, []);

    // Get_Cases_Listing
    useEffect(() => {
        if (oneRequest) {
            oneRequest = false;
            caseListing.getCases(1, formData)
                .then((res) => {
                    setCasesList(res.data.map(item => ({
                        ...item,
                        status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                    })));
                    setPagination(res.meta);
                    setLoading(false)
                }
                ).catch(error => {
                    setLoading(false)
                    console.error('Error fetching data:', error)
                });
        }
    }, []);

    const handleScrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Smooth scrolling behavior
        });
    };

    // Handle_Bookmark_Click
    const handleBookmarkCaseClick = (caseId, bookmark) => {
        setSelectedCaseBookmark(bookmark);
        setSelectedCaseId(caseId);
        if (bookmark === 0) {
            setSelectedCaseBookmark(1);
        } else {
            setSelectedCaseBookmark(0);
        }
    };

    // Handle_Bookmark_Case
    const handleBookmarkCase = () => {
        setShowLoader(true);

        let caseId = selectedCaseId;
        let bookmark = selectedCaseBookmark;

        const requestBody = {
            bookmark: bookmark,
        };

        bookmarkCasee.bookmark(caseId, requestBody)
            .then((res) => {
                setShowLoader(false);
                toast.success(res.message);

                caseListing.getCases(1, formData)
                    .then((res) => {
                        setCasesList(res.data);
                    }
                    ).catch(error => console.error('Error fetching data:', error));
            }
            ).catch((error) => {
                setShowLoader(false);
                toast.error(error.data.message);
            }
            );
        setSelectedCaseId(null);
        setSelectedCaseBookmark(null);
    };

    // Hadle_Page_Click
    const handlePageClick = (pageNo) => {
        setLoading(true)
        if (filteredSearch) {
            caseListing.getCases(pageNo, formData)
                .then((res) => {
                    handleScrollToTop()
                    setCasesList([...res.data]);
                    setPagination(res.meta);
                    setShowFilters(false);
                    setLoading(false)
                    setSorting({
                        column: null,
                        order: 'asc'
                    })
                    if (res?.meta?.last_page > 1) {
                        setFilteredSearch(true)
                    } else {
                        setFilteredSearch(false)
                    }
                })
                .catch(error => console.error('Error fetching data:', error));
        } else {
            caseListing.getCases(pageNo, formData)
                .then((res) => {
                    setLoading(false)
                    setCasesList(res.data);
                    setPagination(res.meta);
                }
                ).catch(error => {
                    setLoading(false)
                    console.error('Error fetching data:', error)
                });
        }
    };

    // Handle_Sort_Table_Data
    const handleSort = (columnName) => {
        setSorting((prevSorting) => ({
            column: columnName,
            order: prevSorting.column === columnName && prevSorting.order === 'asc' ? 'desc' : 'asc',
        }));

        // Sort the data based on the selected column and order
        const sortedData = sortData(casesList, sorting, setSorting, columnName, sorting.order);
        setCasesList(sortedData);
    };

    const isColumnSorted = (columnName) => {
        return sorting.column === columnName;
    };


    // Handle_Delete_CASE
    const handleDeleteCase = () => {
        setLoading(true);
        deleteCase.delete(deleteId)
            .then((res) => {
                setLoading(false);
                toast.success(res.message);
                caseListing.getCases(1, formData)
                    .then((res) => {
                        setLoading(false)
                        setCasesList(res.data.map(item => ({
                            ...item,
                            status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                        })));
                        setPagination(res.meta);
                        setDeleteId(null)
                    }
                    ).catch(error => {
                        setLoading(false)
                        console.error('Error fetching data:', error)
                        setDeleteId(null)
                    });

            }
            ).catch((error) => {
                setLoading(false);
                setDeleteId(null)
                toast.error(error.data.message);
            });
    };

    const handleFilter = (e) => {
        const state = e.target.value;
        setLoading(true)
        setFormData({ ...formData, state })
        caseListing.getCases(1, { ...formData, state })
            .then((res) => {
                setCasesList(res.data.map(item => ({
                    ...item,
                    status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                })));
                setPagination(res.meta);
                setLoading(false)
            }
            ).catch(error => {
                setLoading(false)
                console.error('Error fetching data:', error)
            });
    }

    if (!userExist) {
        return <Navigate to="/login" />
    }

    return (
        <>
            <div className="dbContentWrap">
                {showFilters && <CaseSearch
                    setFilteredSearch={setFilteredSearch}
                    setLoading={setLoading}
                    setShowFilters={setShowFilters}
                    setCasesList={setCasesList}
                    setPagination={setPagination}
                    caseCall={'draft'}
                    formData={formData}
                    setFormData={setFormData}
                />}
                {/* Cases_Listing */}
                <div className="tableWidget">
                    <article className="widgetWrap">
                        <div className="widgetHeader">
                            <span>Draft Cases  <div className="selectWrap posRelative caseFilters">
                                <select onChange={handleFilter} name="cases" className="widgetSelect">
                                    <option value="all">All</option>
                                    <option value="1">One Week</option>
                                    <option value="2">Two Week</option>
                                </select>
                            </div></span>
                            <div className="tabHeadActionWrap">
                                <button onClick={() => {
                                    setShowFilters(true);
                                }} type="button" className={`actionBtn ${showFilters && 'active'}`}>Search Filter <i className="fa-solid fa-filter"></i></button>
                            </div>
                        </div>
                        <div className="tableWrap">
                            <table className="table fontSmall textCenter w100">
                                <thead>
                                    <tr>
                                        <th
                                            className={`sortable ${isColumnSorted('reference') ? ' sorted' : ''}`}
                                            onClick={() => handleSort('reference')}
                                        >Ref <i className="icn fa-solid fa-caret-down"></i></th>
                                        <th
                                            className={`sortable ${isColumnSorted('procedure_date') ? ' sorted' : ''}`}
                                            onClick={() => handleSort('procedure_date')}
                                        >Date <i className="icn fa-solid fa-caret-down"></i></th>
                                        <th>Consultant</th>
                                        <th>Procedure</th>
                                        <th>Comorbidities</th>
                                        <th>Complications</th>
                                        <th>Case Notes</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(casesList && (casesList?.length > 0)) ? casesList.map((data) => (
                                        <tr key={data.id} className={`${(data.bookmark == 1) ? 'bookmarked' : ''}`}>
                                            <td className="caseRefLink" onClick={() => { navigate(`../case/${data.id}`) }} data-label="Ref">{data?.reference}</td>
                                            <td data-label="Date">{data?.procedure_date}</td>
                                            <td data-label="Consultant">{data?.consultant}</td>
                                            <td data-label="Procedure">{data?.procedure}</td>
                                            <td data-label="Comorbidities" data-text-alignment="left">{data.comorbidities ? Object.values(data?.comorbidities).join(', ') : '-'}</td>
                                            <td data-label="Complications" data-text-alignment="left">{data.complications ? Object.values(data?.complications).join(', ') : '-'}</td>
                                            <td data-label="Case Notes" data-text-alignment="left">
                                                <span>
                                                    {data?.note || '-'}
                                                </span>
                                            </td>
                                            <td data-label="Actions">
                                                <div>
                                                    {(permission?.some(p => (p.name === userPermissions.CASES_UPDATE)) && ((data.status !== 'Approved') && (data.status !== 'approved'))) && (
                                                        <button
                                                            type="button"
                                                            onClick={() => { navigate(`/update-case/${data.id}`) }}
                                                            className="actionIcn edit fa-solid fa-pencil"
                                                        ></button>
                                                    )}
                                                    {permission?.some(p => (p.name === userPermissions.CASES_SHOW)) && (
                                                        <button
                                                            type="button"
                                                            onClick={() => { navigate(`../case/${data.id}`) }}
                                                            className="actionIcn edit fa-solid fa-eye"
                                                        ></button>
                                                    )}
                                                    {permission?.some(p => (p.name === userPermissions.CASES_BOOKMARK)) && (
                                                        <button
                                                            type="button"
                                                            onClick={() => handleBookmarkCaseClick(data?.id, data?.bookmark)}
                                                            className={`actionIcn bookmarkIcn ${(data.bookmark === 0) ? 'fa-regular fa-star' : 'fa-solid fa-star'}`}
                                                        ></button>
                                                    )}
                                                    {permission?.some(p => (p.name === userPermissions.CASES_DELETE)) && (
                                                        <button
                                                            type="button"
                                                            onClick={() => setDeleteId(data.id)}
                                                            className='actionIcn edit icn fa-solid fa-folder'
                                                        ></button>
                                                    )}

                                                </div>
                                            </td>
                                        </tr>
                                    )) : loading ?
                                        <tr>
                                            <td colSpan={9}><HalfCircleSpinner
                                                size={18}
                                                color='black'
                                                style={{
                                                    display: "inline-block",
                                                    marginLeft: "7px",
                                                    position: "relative",
                                                    top: "2px",
                                                }}
                                            /></td>
                                        </tr> :
                                        <tr>
                                            <td colSpan={9}>No record found</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className="widgetFooter">
                            <div className="textCenter">
                                {pagination && (Object.keys(pagination)?.length > 0) && (
                                    <Pagination pagination={pagination} handlePageClick={handlePageClick} />
                                )}
                            </div>
                        </div>
                    </article>
                </div>
            </div>
            {/* Bookmark_Case_Popup */}
            <Popup
                className="deleteUserModal"
                open={selectedCaseId !== null && selectedCaseBookmark !== null}
                onClose={() => {
                    setSelectedCaseId(null)
                    setSelectedCaseBookmark(null)
                }}
            >
                {selectedCaseId !== null && (
                    <div className="modal textCenter">
                        <p>Are you sure you want to {selectedCaseBookmark === 0 ? 'close bookmark on' : 'bookmark'}  this case?</p>
                        <div className="btnWrap">
                            <button
                                onClick={() => {
                                    setSelectedCaseId(null)
                                    setSelectedCaseBookmark(null)
                                }}
                                type="button"
                                className="btn btnSecondary"
                            >Cancel</button>
                            <button
                                onClick={handleBookmarkCase}
                                type="button"
                                className="btn btnPrimary"
                                disabled={showLoader}
                            >Confirm
                                {showLoader && (
                                    <HalfCircleSpinner
                                        size={18}
                                        style={{
                                            display: "inline-block",
                                            marginLeft: "7px",
                                            position: 'relative',
                                            top: '2px',
                                        }}
                                    />
                                )}
                            </button>
                        </div>
                    </div>
                )}
            </Popup>

            {/* DELETE_Case_Popup */}
            <Popup
                className="deleteUserModal"
                open={deleteId !== null}
                onClose={() => {
                    setDeleteId(null)
                }}
            >
                {deleteId !== null && (
                    <div className="modal textCenter">
                        <p>Are you sure you want to Archive this case?</p>
                        <div className="btnWrap">
                            <button
                                onClick={() => {
                                    setDeleteId(null)
                                }}
                                type="button"
                                className="btn btnSecondary"
                            >No</button>
                            <button
                                onClick={handleDeleteCase}
                                type="button"
                                className="btn btnPrimary"
                                disabled={showLoader}
                            >Yes
                                {showLoader && (
                                    <HalfCircleSpinner
                                        size={18}
                                        style={{
                                            display: "inline-block",
                                            marginLeft: "7px",
                                            position: 'relative',
                                            top: '2px',
                                        }}
                                    />
                                )}
                            </button>
                        </div>
                    </div>
                )}
            </Popup>
        </>
    )
}

export default DraftCases